import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Form} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import ConfirmModal from '../modals/confirmModal';

class StatusInfo extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.isGrey && this.props.isGrey) {
      this.props.getProductCodePriceFactors('GRIS');
      this.showWarning();
    }
    
    if (prevProps.isGrey && !this.props.isGrey && this.props.productCode) {
      this.props.getProductCodePriceFactors(this.props.productCode);
      this.showWarning();
    }
  }

  showWarning() {
    if (this.props.company) {
      this.props.addMessageBoxWarning('Recuerde actualizar los factores de precio.');
    }
  }

  render() {
    const {isInen, isGrey, discontinued, enabled, allowPriceChange, allowDealersOrders,
      allowSupplierOrders, applyTaxes, isHighValue} = this.props;

    return (
      <Card raised fluid className='status-section'>
        <Form.Group widths='4'>
          <ConfirmModal
            label='INEN (Aduana)'
            fieldName='isInen'
            fieldValue={isInen}
          />
          <ConfirmModal
            label='Descontinuado'
            fieldName='discontinued'
            fieldValue={discontinued}
          />
          <ConfirmModal
            label='Habilitado'
            fieldName='enabled'
            fieldValue={enabled}
          />
          <ConfirmModal
            label='Es Gris'
            fieldName='isGrey'
            fieldValue={isGrey}
          />
        </Form.Group>
        <Form.Group className='second-line' widths='4'>
          <ConfirmModal
            label='Permitir pedidos a TMC'
            fieldName='allowSupplierOrders'
            fieldValue={allowSupplierOrders}
          />
          <ConfirmModal
            label='Permitir pedidos de Concesionario'
            fieldName='allowDealersOrders'
            fieldValue={allowDealersOrders}
          />
          <ConfirmModal
            label='Aplica cambio de precios'
            fieldName='allowPriceChange'
            fieldValue={allowPriceChange}
          />
          <ConfirmModal
            label='Paga impuestos'
            fieldName='applyTaxes'
            fieldValue={applyTaxes}
          />
        </Form.Group>
        <Form.Group className='second-line' widths='4'>
          <ConfirmModal
            label='Pedido Marítimo'
            fieldName='isHighValue'
            fieldValue={isHighValue}
          />
        </Form.Group>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const {values} = state.partsMaster || {};
  const {isInen, isGrey, discontinued, enabled, allowPriceChange, allowDealersOrders,
    allowSupplierOrders, applyTaxes, isHighValue, productCode, company} = values || {};

  return {
    isInen,
    isGrey,
    isHighValue,
    discontinued,
    enabled,
    allowPriceChange,
    allowDealersOrders,
    allowSupplierOrders,
    applyTaxes,
    productCode,
    company,
  };
};

const {getProductCodePriceFactors, addMessageBoxWarning} = Actions;

export default connect(mapStateToProps, {getProductCodePriceFactors, addMessageBoxWarning})(StatusInfo);
